import * as XLSX from 'xlsx';

export const downloadSampleAWBSheet = () => {
  const headers = [['Shipment Number', 'AWB Number']];

  const worksheet = XLSX.utils.aoa_to_sheet(headers);

  // Column width
  worksheet['!cols'] = [{ wch: 25 }, { wch: 25 }];

  // Freeze Header Row
  worksheet['!freeze'] = {
    xSplit: 0,
    ySplit: 1,
  };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Bulk AWB Upload');

  XLSX.writeFile(workbook, 'sample_bulk_awb_upload.xlsx');
};
